import React from "react";
import I18n from "../../../../base/i18n.js";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";

import ButtonLink from "../../../../base/links/button_link.js";

import { CountryModel } from "../../../../models/addresses/country.js";
import ListCountriesUseCase from "../../../../use_cases/admin/addresses/countries/list_countries_use_case.js"

import BaseListPage from "../../base_list_page.js";

import Routes from "../../../routes.js";

const styles = theme => ({
});

class CountriesListPage extends BaseListPage {

  headerContent() {
    const { classes } = this.props;
    return <React.Fragment>
      <ButtonLink className = { classes.button }
                  to = { Routes.country("new") } >
        { I18n.t("admin.addresses.country.action.new") }
      </ButtonLink>
    </React.Fragment>
  }
  
}

CountriesListPage.defaultProps = {
  dataModel: CountryModel,
  listUseCase: ListCountriesUseCase
}

export default compose(
  withLocationSearchFilter,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(CountriesListPage);
